import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';
export default function Testimonial() {
    return (
        <section class="testimonial-section top bottom four-section p-l-r">
            <div className='testimonial-ch'>
                {/* <div className='qoute-icon'>
            <i class="fa-solid fa-quote-left"></i>
        </div> */}
                <div class="mental-health-content">
                    <h3 class="heading2 text_gradient">
                        Testimonial Builds Trust
                    </h3>
                    <p>India's First Vedic Life Sciences App – Trusted by Thousands</p>
                </div>
                <div className='testimonial-slider'>

                    <Swiper
                        slidesPerView={1}
                        spaceBetween={10}
                        // pagination={{
                        //     clickable: true,
                        // }}
                        loop={true}
                        autoplay={{
                            delay: 3500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            640: {
                                slidesPerView: 1.3,
                                spaceBetween: 10,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 10,
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 20,
                            },
                        }}
                        loop={true}
                        modules={[Pagination, Autoplay]}
                        className="mySwiper_2"
                    >
                        <SwiperSlide>
                            <div class="testimonial-card">
                                <div className='testimonial-content p-0'>
                                    <div className='profile-name-g'>
                                        <div className='profile-box'>
                                            <div className='left-box'>
                                                <img src='https://play-lh.googleusercontent.com/a-/ALV-UjVYE1xGOtWh1BCHDEkyerjFXF6jVCH05-mfvaks0U6P8GKjlZbiUA=s64-rw' />
                                            </div>
                                            <div className='right0box'>
                                                <h6>Prabhjot Arora</h6>
                                                {/* <span>9 r/eview</span> */}
                                            </div>
                                        </div>
                                        <div className='right-section-b'>
                                            <img src={require('../assets/images/google_free.png')} />
                                        </div>
                                    </div>
                                </div>

                                <div className='testimonial-content'>
                                    <div className='rating-header'>
                                        <div className='rating-star'>
                                            <div className='rating-box'>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                            </div>
                                            <span>March 07, 2025</span>
                                        </div>
                                    </div>
                                    <p>This exceptional app seamlessly integrates healthy habits, mindful nutrition, children's well-being, and meditation into one holistic platform. It elevates the journey to a balanced lifestyle with effortless ease, making wellness more accessible and enriching. A must-explore for those who value refined living and conscious well-being!</p>

                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div class="testimonial-card">
                                <div className='testimonial-content p-0'>
                                    <div className='profile-name-g'>
                                        <div className='profile-box'>
                                            <div className='left-box'>
                                                <h5>M</h5>
                                            </div>
                                            <div className='right0box'>
                                                <h6>Maahi Gautam</h6>
                                                {/* <span>9 r/eview</span> */}
                                            </div>
                                        </div>
                                        <div className='right-section-b'>
                                            <img src={require('../assets/images/apple-logo.png')} />
                                        </div>
                                    </div>
                                </div>

                                <div className='testimonial-content'>
                                    <div className='rating-header'>
                                        <div className='rating-star'>
                                            <div className='rating-box'>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                            </div>
                                            <span>March 07, 2025</span>
                                        </div>
                                    </div>
                                    <p>The Beyond Lifestyle app ek complete package hai jo healthy habits, mindful eating, meditation, aur kids’ wellness ko ek saath laata hai. Yeh sirf ek app nahi, balki ek healthier aur balanced lifestyle ki taraf ek bada kadam hai. Interface simple aur user-friendly hai, aur content highly informative. Daily habits improve karne aur stress-free jeene ke liye ek must-have app! Definitely 5 stars! </p>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div class="testimonial-card">
                                <div className='testimonial-content p-0'>
                                    <div className='profile-name-g'>
                                        <div className='profile-box'>
                                            <div className='left-box'>
                                                <img src='https://play-lh.googleusercontent.com/a-/ALV-UjX0dYY1TPliy3RySwPz7tjUp8-ONWTCC54fv-tQW7EKCWHttvfZag=s64-rw' />
                                            </div>
                                            <div className='right0box'>
                                                <h6>Anjali Agarwal</h6>
                                                {/* <span>9 review</span> */}
                                            </div>
                                        </div>
                                        <div className='right-section-b'>
                                            <img src={require('../assets/images/google_free.png')} />
                                        </div>
                                    </div>
                                </div>

                                <div className='testimonial-content'>
                                    <div className='rating-header'>
                                        <div className='rating-star'>
                                            <div className='rating-box'>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                            </div>
                                            <span>March 08, 2025</span>
                                        </div>
                                    </div>
                                    <p>I've been using this wellness app for a while, and it has truly enhanced my daily routine. The guided meditations, workout plans, and personalized wellness tips make it a complete package for self-care. The user interface is intuitive, and the reminders help me stay consistent with my health goals. However, adding more customization options for meal plans and integrating a habit tracker would make it even better. Overall, a great app for anyone looking to improve their well-being!</p>

                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div class="testimonial-card">
                                <div className='testimonial-content p-0'>
                                    <div className='profile-name-g'>
                                        <div className='profile-box'>
                                            <div className='left-box'>
                                                <h5>A</h5>
                                            </div>
                                            <div className='right0box'>
                                                <h6>Abhinav Singh Chauhan</h6>
                                                {/* <span>9 r/eview</span> */}
                                            </div>
                                        </div>
                                        <div className='right-section-b'>
                                            <img src={require('../assets/images/apple-logo.png')} />
                                        </div>
                                    </div>
                                </div>

                                <div className='testimonial-content'>
                                    <div className='rating-header'>
                                        <div className='rating-star'>
                                            <div className='rating-box'>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                            </div>
                                            <span>April 18, 2024</span>
                                        </div>
                                    </div>
                                    <p>Attention to details is USP of this app. Brilliant app for mindfulness & lifestyle. Simply superb. Just loved it.</p>

                                </div>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div class="testimonial-card">
                                <div className='testimonial-content p-0'>
                                    <div className='profile-name-g'>
                                        <div className='profile-box'>
                                            <div className='left-box'>
                                                <img src='https://play-lh.googleusercontent.com/a/ACg8ocJbL653JUc1r3cVoi8c6ZwARAT9GUGFn4LMLOLxYGayOls30Q=s64-rw-mo' />
                                            </div>
                                            <div className='right0box'>
                                                <h6>Shivam Kumar</h6>
                                                {/* <span>9 r/eview</span> */}
                                            </div>
                                        </div>
                                        <div className='right-section-b'>
                                            <img src={require('../assets/images/google_free.png')} />
                                        </div>
                                    </div>
                                </div>

                                <div className='testimonial-content'>
                                    <div className='rating-header'>
                                        <div className='rating-star'>
                                            <div className='rating-box'>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                            </div>
                                            <span>January 23, 2025</span>
                                        </div>
                                    </div>
                                    <p>I’m blown away by the variety of resources available in The Beyond Lifestyle App. Whether it’s mindfulness meditation, yoga sessions, insightful Ayurveda tips, or inspiring podcasts, everything is perfectly designed to support my wellness journey. I highly recommend it to anyone serious about self-care!</p>

                                </div>
                            </div>
                        </SwiperSlide>


                        <SwiperSlide>
                            <div class="testimonial-card">
                                <div className='testimonial-content p-0'>
                                    <div className='profile-name-g'>
                                        <div className='profile-box'>
                                            <div className='left-box'>
                                                <h5>R</h5>
                                            </div>
                                            <div className='right0box'>
                                                <h6>Rajatupneja</h6>
                                                {/* <span>9 r/eview</span> */}
                                            </div>
                                        </div>
                                        <div className='right-section-b'>
                                            <img src={require('../assets/images/apple-logo.png')} />
                                        </div>
                                    </div>
                                </div>

                                <div className='testimonial-content'>
                                    <div className='rating-header'>
                                        <div className='rating-star'>
                                            <div className='rating-box'>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                            </div>
                                            <span>January 22, 2025</span>
                                        </div>
                                    </div>
                                    <p>This app has genuinely transformed my daily routine. The mindfulness exercises are quick yet impactful. It’s like having a personal coach in my pocket. Whether I need a quick breathing session or a deep meditation, it’s all here. Thank you for making mindfulness simple!</p>
                                </div>
                            </div>
                        </SwiperSlide>

                    </Swiper>
                </div>
            </div>
        </section>
    )
}
